module.exports = __webpack_public_path__ + "static/media/Gotham-Black.8faba3db.ttf";